import React from "react";

const Sparkle = ({ top, left, size, delay }) => (
  <div
    className={`absolute bg-white rounded-full opacity-70 blur-sm`}
    style={{
      top: `${top}%`,
      left: `${left}%`,
      width: size,
      height: size,
      animation: `twinkle 2s ease-in-out ${delay}s infinite`,
    }}
  />
);

const sparkleCount = {
  subtle: 12,
  normal: 20,
  big: 36,
};

const SparkleEffect = ({ intensity = "normal" }) => {
  if (intensity === "off") return null;

  const sparkles = Array.from({ length: sparkleCount[intensity] || 20 }, () => ({
    top: Math.random() * 100,
    left: Math.random() * 100,
    size: `${Math.random() * 6 + 4}px`,
    delay: Math.random() * 3,
  }));

  return (
    <div className="absolute inset-0 pointer-events-none z-10">
      {sparkles.map((s, i) => (
        <Sparkle key={i} {...s} />
      ))}
    </div>
  );
};

export default SparkleEffect;
